// Copyright (c) 2017 Deere & Company

import './index.scss';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import React from 'react';

const DuplicatePinPlateLinkPanel = () =>
    <div className='duplicate-pin-plate-link-panel'>
        <Link to='/products/duplicate-pin-plate'>
            <FormattedMessage id='REQUEST_DUPLICATE_PIN_PLATE'/>
        </Link>
    </div>;

DuplicatePinPlateLinkPanel.displayName = 'DuplicatePinPlateLinkPanel';

export default DuplicatePinPlateLinkPanel;



// WEBPACK FOOTER //
// ./src/product/shared/components/duplicate-pin-plate-link/index.js